import React from 'react';
import { LoadingSpinner } from './LoadingSkeleton';

export default function PageLoadingOverlay({ 
    isVisible = false, 
    message = 'Loading...', 
    showSpinner = true,
    overlayStyle = {},
    contentStyle = {}
}) {
    if (!isVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
                backdropFilter: 'blur(4px)',
                animation: 'fadeIn 0.3s ease-out',
                ...overlayStyle
            }}
        >
            <div
                style={{
                    background: 'var(--bg-primary)',
                    borderRadius: 'var(--radius-lg)',
                    padding: 'var(--space-8)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 'var(--space-4)',
                    boxShadow: 'var(--shadow-xl)',
                    border: '1px solid var(--border-light)',
                    minWidth: '200px',
                    animation: 'fadeIn 0.4s ease-out',
                    ...contentStyle
                }}
            >
                {showSpinner && (
                    <LoadingSpinner size="48px" />
                )}
                <p style={{
                    margin: 0,
                    fontSize: 'var(--font-size-lg)',
                    fontWeight: 'var(--font-weight-medium)',
                    color: 'var(--text-primary)',
                    textAlign: 'center'
                }}>
                    {message}
                </p>
            </div>
        </div>
    );
} 